var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtmIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49984 3.33332C6.8915 2.29166 8.62484 1.66666 10.4998 1.66666C15.0998 1.66666 18.8332 5.39999 18.8332 9.99999C18.8332 14.6 15.0998 18.3333 10.4998 18.3333C5.89984 18.3333 2.1665 14.6 2.1665 9.99999C2.1665 8.49166 2.56649 7.07498 3.27483 5.84998L10.4998 9.99999",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19166 7.46666C5.74999 8.20833 5.5 9.075 5.5 10C5.5 12.7583 7.74167 15 10.5 15C13.2583 15 15.5 12.7583 15.5 10C15.5 7.24167 13.2583 5 10.5 5C9.74167 5 9.01668 5.16667 8.37501 5.47501",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtmIcon);
export default __webpack_public_path__ + "static/media/rtm_icon.86d27978e1771f39e7976dfe93c47fa5.svg";
export { ForwardRef as ReactComponent };